import React from 'react';

function Dot() {
    return (
        <div className="dotWrapper">
            <div className="dot"></div>
        </div>
    );
};

export default Dot;